import { combineReducers } from 'redux'
import { bgLimitRequestSlice, clientLimitInfoSLice } from 'Pages/ibro'

export * from './slice'
export * from './saga'
export * from './selectors'

export const bgLimits = combineReducers({
	[bgLimitRequestSlice.name]: bgLimitRequestSlice.reducer,
	[clientLimitInfoSLice.name]: clientLimitInfoSLice.reducer,
})
